<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-form :form="form" :class="[PriceShow ? '':'disEvents']">
      <a-form-item style="display:none">
        <a-input v-decorator="['enterpriseDistricePriceId']"/>
      </a-form-item>
      <a-row>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称">
            <a-select
                      showSearch

                      optionFilterProp="children"
                      mode="multiple"
                      :disabled="istrue"
                      v-decorator="['enterpriseIds', { rules: [{ required: true, message:'请选择企业' }] }]">
              <a-select-option v-for="type in enterpriseMap" :key="type.enterpriseId">
                {{type.enterpriseName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
            <a-select  :allowClear="true" :options="installTypeMap" v-decorator="['installType', {rules: [{required: true, message: '请选择安装类别'}]}]" @change="handleSelect"></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额类型">
            <a-select  :allowClear="true" :options="priceTypeMap" v-decorator="['priceType', {rules: [{required: true, message: '请选择金额类型'}]}]"></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域金额">
            <a-input-number style="width: 250px" :min="0"  :step="0.01"  v-decorator="['price', {rules: [{required: true, message: '请填写区域金额'}]}]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请价格">
            <a-select  :allowClear="true" :options="proportionMap" v-decorator="['proportion', {rules: [{required: true, message: '请选择是否申请价格'}]}]">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生效时间">
            <a-range-picker @change="onChangeTime" v-decorator="['time', {rules: [{required: true, message: '请选择生效时间'}]}]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域选择方式（四选一）">
        <a-radio-group name="radioGroup" :default-value="value1" :options="districtTypeMap" v-decorator="['districtType', {rules: [{required: true, message: '请选择区域选择方式'}]}]" @change="areasChange">

        </a-radio-group>
      </a-form-item>
      <a-row v-if="decor==0">
        <a-col :span="12">
        <a-form-item>
          <a-select   v-model="restaurantTypes01item" style="width: 120px" @change="levelchange01">
            <a-select-option v-for="area01 in restaurantTypes01" :key="area01.code">
              {{ area01.label }}
            </a-select-option>
          </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-if="decor==1">
        <a-col :span="12">
          <a-select  v-model="restaurantTypes02item" style="width: 120px" @change="levelchange02">
            <a-select-option v-for="area02 in restaurantTypes02" :key="area02.code">
              {{ area02.label }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <div   v-bind:class="{cityTypeList:cityTypeLists,'areaTypeList':areaTypeLists}" style="position:relative"  v-if="decor==2||datalistshow">
              <div class='minblock'v-for="(proviceitem,proviceindex) in initialprovicearry" @click.stop='lookprovice(proviceindex)'>
                <div>
                  <span class='nonepress'  v-if="proviceitem.checked==0" @click.stop='getcitycode(proviceindex)'></span>
                  <span class='havepress' v-if="proviceitem.checked==1" @click.stop='cancalecitycode(proviceindex)'></span>
                  <span class='nonepress' v-if="proviceitem.checked==2" @click.stop='getcitycode(proviceindex)'><div></div></span>
                  <div class='codename'>{{proviceitem.provinceName}}</div>
                </div>
                <div class='city' v-if='proviceitem.show'>
                  <H2 v-if='cityTypeLists'>{{proviceitem.provinceName}}所属城市</h2>
                  <div class='minblock' v-for="(cityitem,cityindex) in proviceitem.cityTypeList"  @click.stop='lookcity(proviceindex,cityindex)'>
                    <div>
                      <span class='nonepress'  v-if="cityitem.checked==0" @click.stop='getareacode(proviceindex,cityindex)'></span>
                      <span class='havepress' v-if="cityitem.checked==1" @click.stop='cancaleareacode(proviceindex,cityindex)'></span>
                      <span class='nonepress' v-if="cityitem.checked==2" @click.stop='getareacode(proviceindex,cityindex)'><div></div></span>
                      <div class='codename'>{{cityitem.cityName}}</div>
                    </div>

                    <div class='area' v-if='cityitem.show'>
                    <H2 v-if='areaTypeLists'>{{cityitem.cityName}}所属区</h2>
                      <div class='minblock' v-for="(areaitem,areaindex) in cityitem.areaTypeList">
                        <span class='nonepress'  v-if="areaitem.checked==0" @click.stop='getlastcode(proviceindex,cityindex,areaindex)'></span>
                        <span class='havepress' v-if="areaitem.checked==1" @click.stop='cancalelastcode(proviceindex,cityindex,areaindex)'></span>
                        <div class='codename'>{{areaitem.areaName}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      <div  v-bind:class="{cityTypeList:cityTypeLists,'areaTypeList':areaTypeLists}" style="position:relative; "  v-if="decor==3">

        <div  style=" height:200px;" class='minblock'v-for="(templateitem,templateindex) in initialprovicearry" @click.stop='looktemplate(templateindex)'>
          <div>
            <span class='nonepress'  v-if="templateitem.checked==0" @click.stop='templatecode(templateindex)'></span>
            <span class='havepress' v-if="templateitem.checked==1" @click.stop='templatecitycode(templateindex)'></span>
            <span class='nonepress' v-if="templateitem.checked==2" @click.stop='templatecode(templateindex)'><div></div></span>
            <div class='codename'>{{templateitem.templateName}}</div>
          </div>
          <div   class='provice' v-if='templateitem.show'>
            <H2 >{{templateitem.templateName}}所属省</h2>
            <div class='minblock'v-for="(proviceitem,proviceindex) in templateitem.provinceTypeList" @click.stop='lookprovice2(templateindex,proviceindex)'>
              <div>
                <span class='nonepress'  v-if="proviceitem.checked==0" @click.stop='templategetcitycode(templateindex,proviceindex)'></span>
                <span class='havepress' v-if="proviceitem.checked==1" @click.stop='templatecancalecitycode(templateindex,proviceindex)'></span>
                <span class='nonepress' v-if="proviceitem.checked==2" @click.stop='templategetcitycode(templateindex,proviceindex)'><div></div></span>
                <div class='codename'>{{proviceitem.provinceName}}</div>
              </div>
              <div   class='city' v-if='proviceitem.show'>
                <H2 v-if='cityTypeLists'>{{proviceitem.provinceName}}所属城市</h2>
                <div class='minblock' v-for="(cityitem,cityindex) in proviceitem.cityTypeList"  @click.stop='lookcity2(templateindex,proviceindex,cityindex)'>
                  <div>
                    <span class='nonepress'  v-if="cityitem.checked==0" @click.stop='templategetareacode(templateindex,proviceindex,cityindex)'></span>
                    <span class='havepress' v-if="cityitem.checked==1" @click.stop='templatecancaleareacode(templateindex,proviceindex,cityindex)'></span>
                    <span class='nonepress' v-if="cityitem.checked==2" @click.stop='templategetareacode(templateindex,proviceindex,cityindex)'><div></div></span>
                    <div class='codename'>{{cityitem.cityName}}</div>
                  </div>

                  <div  class='area' v-if='cityitem.show'>
                    <H2 v-if='areaTypeLists'>{{cityitem.cityName}}所属区</h2>
                    <div class='minblock' v-for="(areaitem,areaindex) in cityitem.areaTypeList">
                      <span class='nonepress'  v-if="areaitem.checked==0" @click.stop='templategetlastcode(templateindex,proviceindex,cityindex,areaindex)'></span>
                      <span class='havepress' v-if="areaitem.checked==1" @click.stop='templatecancalelastcode(templateindex,proviceindex,cityindex,areaindex)'></span>
                      <div class='codename'>{{areaitem.areaName}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a-divider/>
      <a-row >
        <a-col :span="24" :style="{ textAlign: 'right' }" v-if="PriceShow">
          <a-button  @click="() => visible=false ">取消</a-button>
          <a-button style="margin-left: 8px" type="primary"  @click="handleSubmit">确定</a-button>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import { getBasicPriceList } from '@/api/basicdatas/OrderType'
import { getselectCombox } from '@/api/order/NewlyaddedOrderList'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import store from '@/store'
import moment from 'moment';
export default {
  name: 'EnterpriseDistrictPriceModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      store,
      price:'', // 克隆区域金额
    value1:'',
      districtTypeMap:[{'label':'城市等级','value':'0'},{'label':'区域级别','value':'1'},{'label':'行政区域','value':'2'},{'label':'选择自定义区域','value':'3'}],
      proportionMap:[{'label':'否','value':0},{'label':'是','value':1}],
    restaurantTypes01item:'选择',
    restaurantTypes02item:'选择',
    restaurantTypes01:[],
    restaurantTypes02:[{'label':'一级','code':1},{'label':'二级','code':2},{'label':'三级','code':3},{'label':'四级','code':4},{'label':'五级','code':5},{'label':'六级','code':6},],
    decor:5,
      istrue:false,
    areaTypeLists:false,
    cityTypeLists:false,
     initialprovicearry:[],
      datalistshow:false,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      installTypeMap: [],
      priceTypeMap: [],
      beginTime: '',
      endTime: '',
      enterpriseMap: [],
      restaurantOperTypeMap:'',
      PriceShow:false,
      districtPriceId:''
    }
  },
  beforeCreate () {
  },
  async created () {

    // 选择城市等级
    this.restaurantOperTypeMap = await getDictMap('city_grade');
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.restaurantTypes01.push({code: key, label: value})
      })
      console.log('一线',this.restaurantTypes01)
    // 安装类别
    this.installTypeArr = await getDictMap('install_type')
    this.installTypeArr.forEach((value, key) => {
      this.installTypeMap.push({ value: key, label: value })
    })

    // 金额类型
    this.priceTypeArr = await getBasicPriceList()
    console.log('this.priceTypeArr',this.priceTypeArr)
    this.priceTypeArr.rows.forEach(price => {
      this.priceTypeMap.push({ value: price.id, label: price.priceName})
    })

    await getselectCombox().then(res => {
      if (res.code === 0) {
        this.enterpriseMap = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  methods: {
    moment,
    handleSelect(value){
      this.priceTypeMap = []
      this.form.setFieldsValue({priceType:undefined})
      getBasicPriceList({installationType:value}).then(res=>{
        res.rows.forEach(price => {
          this.priceTypeMap.push({ value: price.id, label: price.priceName})
        })
      })
    },
    handleCancel(){//关闭弹窗手动处理数据状态
     this.value1=''
      this.confirmLoading=false
      this.restaurantOperTypeMap='',
      this.restaurantTypes01item='选择',
     this.restaurantTypes02item='选择',
     this.decor=5,
     this.areaTypeLists=false,
     this.cityTypeLists=false,
    this.initialprovicearry=[],
    this.datalistshow=false
    this.visible=false
    this.form.resetFields()
    },
    levelchange01(value){
      console.log(value,'levelchange01levelchange01levelchange01')
      this.restaurantTypes01item=value,
      this.restaurantTypes02item='选择',
      this.getprovice('cityGrade',value)
      console.log('this.restaurantTypes01item',this.restaurantTypes01item)
    },
    levelchange02(value){
      this.restaurantTypes01item='选则',
      this.restaurantTypes02item=value,
      console.log('this.restaurantTypes02item',this.restaurantTypes02item)
      this.getprovice('areaGrade',value)
    },
    areasChange(e){//点击选择区域模板
      console.log(e)
      this.cityTypeLists=false
      this.areaTypeLists=false
      this.restaurantTypes01item='选择',
      this.restaurantTypes02item='选择',
      this.initialprovicearry=[],
      this.datalistshow=false
      this.decor=e.target.value
      this.value1=e.target.value
      if(e.target.value!=0&&e.target.value!=1){
        this.getprovicearea(this.decor)
        console.log('this.decor',this.decor)
      }
    },
    getprovice(a,b){//获取数据源前两个
      this.$axios({
        url: '/api/basicdata/city/cityGrade?'+a+'='+b,
        method: 'get',
        headers: {
          'token': Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
        }).then((res) => {
        if(res.data.code==0){
        console.log('城市',res.data)
          for(var i=0;i<res.data.rows.length;i++){
            res.data.rows[i].show=false,
            res.data.rows[i].checked=0
            for(var j=0;j<res.data.rows[i].cityTypeList.length;j++){
              res.data.rows[i].cityTypeList[j].show=false
              res.data.rows[i].cityTypeList[j].checked=0
              for(var k=0;k<res.data.rows[i].cityTypeList[j].areaTypeList.length;k++){
                res.data.rows[i].cityTypeList[j].areaTypeList[k].checked=0
              }
            }
          }
          this.initialprovicearry=res.data.rows
          this.datalistshow=true
          console.log('res.datasasd',res.data)
        }
      })
    },
    getprovicearea(key){//获取数据源后两个
      if(key==2){
        this.$axios({
          url: '/api/basicdata/districtTemplate/getCustomArea/-1',
          method: 'get',
          headers: {
            'token': Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          if(res.data.code==0){
            for(var i=0;i<res.data.rows.length;i++){
              res.data.rows[i].show=false
              for(var j=0;j<res.data.rows[i].cityTypeList.length;j++){
                res.data.rows[i].cityTypeList[j].show=false
              }
            }
            this.initialprovicearry=res.data.rows
            this.datalistshow=true
            console.log('res.datasasd',res.data)
          }
        })
      }else{
        //选择自定义区域
        this.$axios({
          url: '/api/basicdata/districtTemplate/customTemplateArea',
          method: 'get',
          headers: {
            'token': Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then((res) => {
          console.log(res.data.rows)
          if(res.data.code==0){
            for(var i=0;i<res.data.rows.length;i++){
              res.data.rows[i].show=false
              for(var k=0;k<res.data.rows[i].provinceTypeList.length;k++){
                res.data.rows[i].provinceTypeList[k].show=false
                for(var j=0;j<res.data.rows[i].provinceTypeList[k].cityTypeList.length;j++){
                  res.data.rows[i].provinceTypeList[k].cityTypeList[j].show=false
                }
              }
            }
            this.initialprovicearry=res.data.rows
          }
        })
      }


    },
    getcitycode(proviceindex){//省打勾
      this.initialprovicearry[proviceindex].checked=1
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        this.initialprovicearry[proviceindex].cityTypeList[i].checked=1
        for(var j=0;j<this.initialprovicearry[proviceindex].cityTypeList[i].areaTypeList.length;j++){
          this.initialprovicearry[proviceindex].cityTypeList[i].areaTypeList[j].checked=1
        }
      }
    },
    cancalecitycode(proviceindex){//省去掉打勾
      this.initialprovicearry[proviceindex].checked=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        this.initialprovicearry[proviceindex].cityTypeList[i].checked=0
        for(var j=0;j<this.initialprovicearry[proviceindex].cityTypeList[i].areaTypeList.length;j++){
          this.initialprovicearry[proviceindex].cityTypeList[i].areaTypeList[j].checked=0
        }
      }
    },
    getareacode(proviceindex,cityindex){//市打勾
      this.initialprovicearry[proviceindex].cityTypeList[cityindex].checked=1
      var cnum=0
      var snum=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[proviceindex].cityTypeList[i].checked==1){
          cnum++
        }if(this.initialprovicearry[proviceindex].cityTypeList[i].checked==0){
          snum++
        }
        for(var j=0;j<this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList.length;j++){
          this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList[j].checked=1
        }
      }
      if(cnum==this.initialprovicearry[proviceindex].cityTypeList.length){
        this.initialprovicearry[proviceindex].checked=1
      }else{
        if(snum==this.initialprovicearry[proviceindex].cityTypeList.length){
          this.initialprovicearry[proviceindex].checked=0
        }else{
          this.initialprovicearry[proviceindex].checked=2
        }
      }
    },
    cancaleareacode(proviceindex,cityindex){//市去掉打勾
      this.initialprovicearry[proviceindex].cityTypeList[cityindex].checked=0
      var num=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[proviceindex].cityTypeList.checked!=0){
          num++
        }
        for(var j=0;j<this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList.length;j++){
          this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList[j].checked=0
        }
      }
      if(num==0){
        this.initialprovicearry[proviceindex].checked=0
      }else{
        this.initialprovicearry[proviceindex].checked=2
      }
    },
    getlastcode(proviceindex,cityindex,areaindex){//区选中
      this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList[areaindex].checked=1
      var num=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList.length;i++){
        if(this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList[i].checked==1){
          num++
        }
      }
      if(num==this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList.length){
        this.initialprovicearry[proviceindex].cityTypeList[cityindex].checked=1
      }else{
        this.initialprovicearry[proviceindex].cityTypeList[cityindex].checked=2
      }
      var cnum=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[proviceindex].cityTypeList[i].checked==1){
          cnum++
        }
      }
      if(cnum==this.initialprovicearry[proviceindex].cityTypeList.length){
        this.initialprovicearry[proviceindex].checked=1
      }else{
        this.initialprovicearry[proviceindex].checked=2
      }
    },
    cancalelastcode(proviceindex,cityindex,areaindex){//区去掉打勾
      this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList[areaindex].checked=0
      var num=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList.length;i++){
        if(this.initialprovicearry[proviceindex].cityTypeList[cityindex].areaTypeList[i].checked==1){
          num++
        }
      }
      if(num!=0){
        this.initialprovicearry[proviceindex].cityTypeList[cityindex].checked=2
      }else{
        this.initialprovicearry[proviceindex].cityTypeList[cityindex].checked=0
      }
      var cnum=0
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[proviceindex].cityTypeList[i].checked!=0){
          cnum++
        }
      }
      if(cnum!=0){
        this.initialprovicearry[proviceindex].checked=2
      }else{
        this.initialprovicearry[proviceindex].checked=0
      }
    },
    //自定义区域
    looktemplate(proviceindex){
      this.initialprovicearry[proviceindex].show=!this.initialprovicearry[proviceindex].show
      for(var i=0;i<this.initialprovicearry.length;i++){
        if(i!=proviceindex){
          this.initialprovicearry[i].show=false
        }
        for(var j=0;j<this.initialprovicearry[i].provinceTypeList.length;j++){
          this.initialprovicearry[i].provinceTypeList[j].show=false
        }
      }
    },
    lookprovice2(proviceindex,cityindex){//市展开缩起
      this.areaTypeLists=false
      if(!this.initialprovicearry[proviceindex].provinceTypeList[cityindex].show){
        this.cityTypeLists=true
      }else{
        this.cityTypeLists=false
      }
      this.initialprovicearry[proviceindex].provinceTypeList[cityindex].show=!this.initialprovicearry[proviceindex].provinceTypeList[cityindex].show
      for(var i=0;i<this.initialprovicearry[proviceindex].provinceTypeList.length;i++){
        if(i!=cityindex){
          this.initialprovicearry[proviceindex].provinceTypeList[i].show=false
        }
        for(var j=0;j<this.initialprovicearry[proviceindex].provinceTypeList[i].cityTypeList.length;j++){
          this.initialprovicearry[proviceindex].provinceTypeList[i].cityTypeList[j].show=false
        }
      }
    },
    lookcity2(templateindex,proviceindex,cityindex){//区展开缩起
      console.log('this.areaTypeLists',this.cityTypeLists)
      if(!this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].show){
        this.areaTypeLists=true
      }else{
        this.areaTypeLists=false
      }
      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].show=!this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].show
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;i++){
        if(i!=cityindex){
          this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[i].show=false
        }
      }
    },

    templatecitycode(proviceindex){//模板去掉打钩
      this.initialprovicearry[proviceindex].checked=0
      for(var k=0;k<this.initialprovicearry[proviceindex].provinceTypeList.length;k++){
        this.initialprovicearry[proviceindex].provinceTypeList[k].checked=0
        for(var i=0;i<this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList.length;i++){
          this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList[i].checked=0
          for(var j=0;j<this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList[i].areaTypeList.length;j++){
            this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList[i].areaTypeList[j].checked=0
          }
        }
      }
    },
    templatecode(proviceindex){//模板打钩
      this.initialprovicearry[proviceindex].checked=1
      for(var k=0;k<this.initialprovicearry[proviceindex].provinceTypeList.length;k++){
        this.initialprovicearry[proviceindex].provinceTypeList[k].checked=1
        for(var i=0;i<this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList.length;i++){
          this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList[i].checked=1
          for(var j=0;j<this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList[i].areaTypeList.length;j++){
            this.initialprovicearry[proviceindex].provinceTypeList[k].cityTypeList[i].areaTypeList[j].checked=1
          }
        }
      }
    },
    templategetcitycode(templateindex,proviceindex){
      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=1
      var cnum=0
      var snum=0

      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[i].checked==1){
          cnum++
        }if(this.initialprovicearry[templateindex].provinceTypeList[i].checked==0){
          snum++
        }
        for(var j=0;j<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;j++){
          this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[j].checked=1
          for(var k=0;k<this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[j].areaTypeList.length;k++){
            this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[j].areaTypeList[k].checked=1
          }
        }
      }
      if(cnum==this.initialprovicearry[templateindex].provinceTypeList.length){
        this.initialprovicearry[templateindex].checked=1
      }else{
        if(snum==this.initialprovicearry[templateindex].provinceTypeList.length){
          this.initialprovicearry[templateindex].checked=0
        }else{
          this.initialprovicearry[templateindex].checked=2
        }
      }
    },
    templatecancalecitycode(templateindex,proviceindex){//省取消打钩

      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=0
      var num=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList.checked!=0){
          num++
        }
        for(var j=0;j<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;j++){
          this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[j].checked=0
          for(var k=0;k<this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[j].areaTypeList.length;k++){
            this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[j].areaTypeList[k].checked=0
          }
        }
      }
      if(num==0){
        this.initialprovicearry[templateindex].checked=0
      }else{
        this.initialprovicearry[templateindex].checked=2
      }
    },
    templategetareacode(templateindex,proviceindex,cityindex){//自定义区域市打钩
      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].checked=1
      for(var k=0;k<this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList.length;k++){
        this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList[k].checked=1
      }
      var num=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[i].checked==1){
          num++
        }
      }
      if(num==this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length){
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=1
      }else{
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=2
      }
      var cnum=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[i].checked==1){
          cnum++
        }
      }
      if(cnum==this.initialprovicearry[templateindex].provinceTypeList.length){
        this.initialprovicearry[templateindex].checked=1
      }else{
        this.initialprovicearry[templateindex].checked=2
      }
    },
    templatecancaleareacode(templateindex,proviceindex,cityindex){//自定义区域市取消打钩
      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].checked=0
      for(var k=0;k<this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList.length;k++){
        this.initialprovicearry[proviceindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList[k].checked=0
      }
      var num=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[i].checked==0){
          num++
        }
      }
      if(num!=0){
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=2
      }else{
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=0
      }
      var cnum=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[i].checked!=0){
          cnum++
        }
      }
      if(cnum!=0){
        this.initialprovicearry[templateindex].checked=2
      }else{
        this.initialprovicearry[templateindex].checked=0
      }
    },
    templategetlastcode(templateindex,proviceindex,cityindex,areaindex){//区打钩
      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList[areaindex].checked=1

      var Anum=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList[i].checked==1){
          Anum++
        }
      }
      if(Anum==this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList.length){
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].checked=1
      }else{
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].checked=2
      }


      var num=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[i].checked==1){
          num++
        }
      }
      if(num==this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length){
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=1
      }else{
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=2
      }
      var cnum=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[i].checked==1){
          cnum++
        }
      }
      if(cnum==this.initialprovicearry[templateindex].provinceTypeList.length){
        this.initialprovicearry[templateindex].checked=1
      }else{
        this.initialprovicearry[templateindex].checked=2
      }
    },
    templatecancalelastcode(templateindex,proviceindex,cityindex,areaindex){//区取消打钩

      this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList[areaindex].checked=0

      var Anum=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].areaTypeList[i].checked==0){
          Anum++
        }
      }
      if(Anum!=0){
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].checked=2
      }else{
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[cityindex].checked=0
      }

      var num=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[proviceindex].cityTypeList[i].checked==0){
          num++
        }
      }
      if(num!=0){
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=2
      }else{
        this.initialprovicearry[templateindex].provinceTypeList[proviceindex].checked=1
      }

      var cnum=0
      for(var i=0;i<this.initialprovicearry[templateindex].provinceTypeList.length;i++){
        if(this.initialprovicearry[templateindex].provinceTypeList[i].checked==0){
          cnum++
        }
      }

      if(cnum!=0){
        this.initialprovicearry[templateindex].checked=1
      }else{
        this.initialprovicearry[templateindex].checked=2
      }
    },

    lookprovice(proviceindex){//市展开缩起
      this.areaTypeLists=false
      if(!this.initialprovicearry[proviceindex].show){
        this.cityTypeLists=true
      }else{
        this.cityTypeLists=false

      }
      console.log(' this.cityTypeLists', this.cityTypeLists)
      this.initialprovicearry[proviceindex].show=!this.initialprovicearry[proviceindex].show
      for(var i=0;i<this.initialprovicearry.length;i++){
        if(i!=proviceindex){
          this.initialprovicearry[i].show=false
        }
        for(var j=0;j<this.initialprovicearry[i].cityTypeList.length;j++){
          this.initialprovicearry[i].cityTypeList[j].show=false
        }
      }
    },
    lookcity(proviceindex,cityindex){//区展开缩起
      console.log('this.areaTypeLists',this.cityTypeLists)
      if(!this.initialprovicearry[proviceindex].cityTypeList[cityindex].show){
        this.areaTypeLists=true
      }else{
        this.areaTypeLists=false
      }
      this.initialprovicearry[proviceindex].cityTypeList[cityindex].show=!this.initialprovicearry[proviceindex].cityTypeList[cityindex].show
      for(var i=0;i<this.initialprovicearry[proviceindex].cityTypeList.length;i++){
        if(i!=cityindex){
          this.initialprovicearry[proviceindex].cityTypeList[i].show=false
        }
      }
    },
    add (record,code) {
      this.districtPriceId=record
      this.form.resetFields()
      this.edit(record)
      if(this.store.getters.enterpriseId){
        this.istrue = true
      }
      if(code==0){
        this.PriceShow=false
      }else{
        this.PriceShow=true
      }
    },
    edit (record) {//对请求来的详情数据进行处理以供展示
       this.$axios({
              url: '/api/enterprise/districtPrice/get/'+record,
              method: 'GET',
              headers: {
                'token': Vue.ls.get(ACCESS_TOKEN),
                'Content-Type': 'application/json;charset=UTF-8'
              }
              }).then((res) => {
              console.log('详情',res.data)
                if(res.data.code==0){
                  this.mdl = Object.assign(res.data.data)
                  this.price = this.mdl.price
                  this.cityTypeLists=false
                  this.areaTypeLists=false
                  this.visible = true
                  this.handleSelect(this.mdl.installType)
                  this.beginTime=res.data.data.beginTime
                  this.endTime=res.data.data.endTime
                  if(this.beginTime != null && this.endTime != null){
                    this.mdl.time = [moment(this.beginTime), moment(this.endTime)]
                  }

                  this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.mdl, 'enterpriseIds','installType','priceType','price','proportion','time','districtType'))
                  })
                  this.initialprovicearry=JSON.parse(res.data.data.showText)
                  console.log(this.initialprovicearry,'this.initialprovicearry')
                  if(res.data.data.districtType==3){
                    for(let i=0;i<this.initialprovicearry.length;i++){
                      if(this.initialprovicearry[i].provinceTypeList.length!=0){
                        for (let k=0;k<this.initialprovicearry[i].provinceTypeList.length;k++) {
                          if(this.initialprovicearry[i].provinceTypeList[k].show){
                            this.cityTypeLists=true
                          }
                          if(this.initialprovicearry[i].provinceTypeList[k].cityTypeList.length!=0){
                            for (let j=0;j<this.initialprovicearry[i].provinceTypeList[k].cityTypeList.length;j++) {
                              if(this.initialprovicearry[i].provinceTypeList[k].cityTypeList[j].show){
                                this.areaTypeLists=true
                              }
                            }
                          }
                        }
                      }
                    }
                  }else {
                    this.datalistshow=true
                    for (let k=0;k<this.initialprovicearry.length;k++) {
                      if(this.initialprovicearry[k].show){
                        this.cityTypeLists=true
                      }
                      if(this.initialprovicearry[k].cityTypeList.length!=0){
                        for (let j=0;j<this.initialprovicearry[k].cityTypeList.length;j++) {
                          if(this.initialprovicearry[k].cityTypeList[j].show){
                            this.areaTypeLists=true
                          }
                        }
                      }
                    }
                  }
                  this.value1=res.data.data.districtType
                  this.decor=this.value1
                  if(this.decor==0){
                    this.restaurantTypes01item=res.data.data.districtTypeValue
                  }else if(this.decor==1){
                    this.restaurantTypes02item= res.data.data.districtTypeValue-0
                  }

                }else{
                  this.$message.error(res.msg)
                }
              })
    },
    onChangeTime (date) {
      console.log(date)
      if (date) {
        this.beginTime = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.endTime = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    subthing(area,b){//单独拎出来的提交所有信息函数
      var that=this
      if(area.length==0){
        this.$message.error('区域至少得有一个县或者区')
      }else{
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            this.confirmLoading = true
            values['beginTime'] = this.beginTime
            values['endTime'] = this.endTime
            values['oldPrice'] = this.price
            console.log('提交',values)
            this.$axios({
              url: '/api/enterprise/districtPrice/update',
              method: 'POST',
              headers: {
                'token': Vue.ls.get(ACCESS_TOKEN),
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data:{
                'districtPriceId':this.districtPriceId,
                'oldPrice': values.oldPrice,
                'enterpriseIds':values.enterpriseIds,
                'installType':values.installType,
                'priceType':values.priceType,
                'price':values.price,
                'proportion': values.proportion,
                'beginTime':values.beginTime,
                'endTime':values.endTime,
                'districtType': values.districtType,
                'districtTypeValue':b,
                'showText':JSON.stringify(this.initialprovicearry),
                'areaCodeList':area
              }
              }).then((res) => {
              console.log('res',res.data.code)
                if(res.data.code==0){
                  this.$message.success('提交成功')
                  this.$emit('ok')
                  that.handleCancel()
                }else{
                  this.$message.error(res.msg)
                }
              })
            // saveEnterpriseDistrictPrice(values).then(res => {
            //   if (res.code === 0) {
            //     this.$message.success('保存成功')
            //     this.$emit('ok')
            //     this.visible = false
            //   } else {
            //     this.$message.success(res.msg)
            //   }
            // }).catch(() => {
            //   this.$message.error('系统错误，请稍后再试')
            // }).finally(() => {
            //   this.confirmLoading = false
            // })
          }
        })
      }
    },
    handleSubmit (e) {//提交所有信息动作  等级下拉框和区域展示是手动写的，所以得手动判断下再提交
      e.preventDefault()
      var area=[]
      var that=this

      if(this.decor==0){
        if(this.restaurantTypes01item=='选择'){
          this.$message.error('请选择城市等级')
        }else{
          for(var i=0;i<this.initialprovicearry.length;i++){
            if(this.initialprovicearry[i].checked!=0){
              for(var j=0;j<this.initialprovicearry[i].cityTypeList.length;j++){
                if( this.initialprovicearry[i].cityTypeList[j].checked!=0){
                  for(var k=0;k<this.initialprovicearry[i].cityTypeList[j].areaTypeList.length;k++){
                    if(this.initialprovicearry[i].cityTypeList[j].areaTypeList[k].checked==1){
                      area.push(this.initialprovicearry[i].cityTypeList[j].areaTypeList[k].areaCode)
                    }
                  }
                }
              }
            }
          }
          this.subthing(area,this.restaurantTypes01item)
        }
      }else if(this.decor==1){
        if(this.restaurantTypes02item=='选择'){
          this.$message.error('请选择区域级别')
        }else{
          for(var i=0;i<this.initialprovicearry.length;i++){
            if(this.initialprovicearry[i].checked!=0){
              for(var j=0;j<this.initialprovicearry[i].cityTypeList.length;j++){
                if( this.initialprovicearry[i].cityTypeList[j].checked!=0){
                  for(var k=0;k<this.initialprovicearry[i].cityTypeList[j].areaTypeList.length;k++){
                    if(this.initialprovicearry[i].cityTypeList[j].areaTypeList[k].checked==1){
                      area.push(this.initialprovicearry[i].cityTypeList[j].areaTypeList[k].areaCode)
                    }
                  }
                }
              }
            }
          }
          this.subthing(area,this.restaurantTypes02item)
        }
      }else if (this.decor==2) {
        for(var i=0;i<this.initialprovicearry.length;i++){
          if(this.initialprovicearry[i].checked!=0){
            for(var j=0;j<this.initialprovicearry[i].cityTypeList.length;j++){
              if( this.initialprovicearry[i].cityTypeList[j].checked!=0){
                for(var k=0;k<this.initialprovicearry[i].cityTypeList[j].areaTypeList.length;k++){
                  if(this.initialprovicearry[i].cityTypeList[j].areaTypeList[k].checked==1){
                    area.push(this.initialprovicearry[i].cityTypeList[j].areaTypeList[k].areaCode)
                  }
                }
              }
            }
          }
        }
        this.subthing(area,'')
      }else if (this.decor==3){
        for(var i=0;i<this.initialprovicearry.length;i++){
          if(this.initialprovicearry[i].checked!=0){
            for(var j=0;j<this.initialprovicearry[i].provinceTypeList.length;j++){
              if( this.initialprovicearry[i].provinceTypeList[j].checked!=0){
                for(var k=0;k<this.initialprovicearry[i].provinceTypeList[j].cityTypeList.length;k++){
                  if(this.initialprovicearry[i].provinceTypeList[j].cityTypeList[k].checked!=0){
                    for(var v=0;v<this.initialprovicearry[i].provinceTypeList[j].cityTypeList[k].areaTypeList.length;v++){
                      if(this.initialprovicearry[i].provinceTypeList[j].cityTypeList[k].areaTypeList[v].checked==1){
                        area.push(this.initialprovicearry[i].provinceTypeList[j].cityTypeList[k].areaTypeList[v])
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.subthing(area,'')
      }


    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
  .cityTypeList{
    padding-bottom:500px
  }
  .areaTypeList{
    padding-bottom:500px
  }
  .minblock{
    display:inline-block;
    margin-right: 10px;
    margin-bottom: 10px;

  }
  .minblock span,.codename{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    color: rgba(0, 0, 0, 0.65);
    line-height:14px;
    vertical-align:middle;
  }
  .minblock span{
    width: 16px;
    height: 16px;
    border-radius: 2px;
    border-collapse: separate;
    transition: all .3s;
    cursor:pointer;
    overflow:hidden;
  }
  .minblock span.nonepress{
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    border-collapse: separate;
    background-color: #fff;
    border: 1px solid #d9d9d9;
  }
  .minblock span div{
  margin-left:3px;
  margin-top:3px;
  width:8px;
  height:8px;
  background:#1890ff
  }
  .minblock span.nonepress:hover{
  border-color: #1890ff;
  }
  .minblock span.havepress{
    position:relative;
    background-color: #1890ff;
    border: 1px solid #d9d9d9;
  }
  .minblock span.havepress:after{
      left: 4.57142857px;
    top: 1.14285714px;
    display: table;
    width: 5.71428571px;
    height: 9.14285714px;
  transform: rotate(45deg) scale(1);
    position: absolute;
    display: table;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
    content: ' ';
    -webkit-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    opacity: 1;
  }
  .city,.area,.provice{
    position:absolute;
    left:0;
    top:170px;
    width:100%;
  }
  .provice{
    background:#fff;
    top: 150px;
  }
  .city{
    background:#fff
  }
  .area{
    background:#fff
  }
  .disEvents{
    pointer-events: none;
  }
</style>
